import { TodoTask } from "../todolist/add-todo/addTodoList";
import { NoteProps } from "../note/note";
import { useAuthStore } from './auth';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://backend.iceking.wtf/api';

const getAuthHeaders = () => {
  const token = useAuthStore.getState().token;
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

const getHeaders = () => ({
  'Content-Type': 'application/json',
  ...getAuthHeaders(),
});

export interface TodosContainer {
  todos: TodoTask[]
}

export const processNoteApi = {
  async extractTodosFromNotes(notes: NoteProps): Promise<TodosContainer> {
    const response = await fetch(`${API_BASE_URL}/process-notes`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ notes }),
    });

    if (!response.ok) {
      throw new Error('Failed to extract todos from notes');
    }

    const todos = await response.json();
    return todos;
  },
};